function isElementInViewport (el) {
  var rect = el.getBoundingClientRect();

  return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
      rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
  );
}

// Match the reference scroll-linked fade on image slides in the stacked
// product gallery. The carousel layout and mobile gallery remain unchanged.
const initializeMainCarouselScrollFade = () => {
  const carousel = document.querySelector('.product-wrapper.is-stacked #main-carousel');
  if (!carousel) return;

  const scrollContainer = carousel.closest('.product-wrapper');
  if (!scrollContainer) return;

  const images = Array.from(carousel.querySelectorAll('.product__media-item'))
    .map((slide) => slide.querySelector('img'))
    .filter(Boolean);
  if (!images.length) return;

  const desktopQuery = window.matchMedia('(min-width: 769px)');
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  let animationFrame = null;
  let isEnabled = false;

  const updateOpacity = () => {
    animationFrame = null;
    const containerBounds = scrollContainer.getBoundingClientRect();
    const viewportTop = Math.max(0, containerBounds.top);
    const viewportBottom = Math.min(
      window.innerHeight || document.documentElement.clientHeight,
      containerBounds.bottom
    );
    const viewportHeight = Math.max(0, viewportBottom - viewportTop);

    images.forEach((image, index) => {
      const slide = image.closest('.product__media-item');
      const bounds = slide.getBoundingClientRect();
      const visibleHeight = Math.max(
        0,
        Math.min(bounds.bottom, viewportBottom) - Math.max(bounds.top, viewportTop)
      );
      const fullyVisibleHeight = Math.min(bounds.height, viewportHeight);
      const visibilityProgress = fullyVisibleHeight > 0
        ? Math.min(1, Math.max(0, visibleHeight / fullyVisibleHeight))
        : 0;
      let opacity = 0.4 + (visibilityProgress * 0.6);

      if (index === 0 && scrollContainer.scrollTop <= 1) {
        opacity = 1;
      }

      image.style.setProperty('--main-carousel-scroll-opacity', opacity.toFixed(3));
    });
  };

  const requestOpacityUpdate = () => {
    if (animationFrame !== null) return;
    animationFrame = requestAnimationFrame(updateOpacity);
  };

  const enable = () => {
    if (isEnabled) return;
    isEnabled = true;

    images.forEach((image) => {
      image.classList.add('main-carousel-scroll-fade');
      image.style.willChange = 'opacity';
    });

    scrollContainer.addEventListener('scroll', requestOpacityUpdate, { passive: true });
    window.addEventListener('scroll', requestOpacityUpdate, { passive: true });
    window.addEventListener('resize', requestOpacityUpdate);
    updateOpacity();
  };

  const disable = () => {
    if (!isEnabled) return;
    isEnabled = false;

    scrollContainer.removeEventListener('scroll', requestOpacityUpdate);
    window.removeEventListener('scroll', requestOpacityUpdate);
    window.removeEventListener('resize', requestOpacityUpdate);

    if (animationFrame !== null) {
      cancelAnimationFrame(animationFrame);
      animationFrame = null;
    }

    images.forEach((image) => {
      image.classList.remove('main-carousel-scroll-fade');
      image.style.removeProperty('--main-carousel-scroll-opacity');
      image.style.removeProperty('will-change');
    });
  };

  const sync = () => {
    if (desktopQuery.matches && !reducedMotionQuery.matches) {
      enable();
    } else {
      disable();
    }
  };

  const addQueryListener = (query) => {
    if (query.addEventListener) {
      query.addEventListener('change', sync);
    } else {
      query.addListener(sync);
    }
  };

  addQueryListener(desktopQuery);
  addQueryListener(reducedMotionQuery);
  sync();
};

const scheduleMainCarouselScrollFade = () => {
  requestAnimationFrame(initializeMainCarouselScrollFade);
};

if (document.readyState === 'complete') {
  scheduleMainCarouselScrollFade();
} else {
  document.addEventListener('DOMContentLoaded', scheduleMainCarouselScrollFade, { once: true });
}

const atcObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {      
      if(entry.isIntersecting){
        entry.target.closest('.product-wrapper').querySelector('.sticky-atc').classList.remove('active');
      } else {
        entry.target.closest('.product-wrapper').querySelector('.sticky-atc').classList.add('active');
      }
    });
  },
  {
    threshold: 0.25
  }
);

const atcObserver2 = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {      
      if(entry.isIntersecting){
        if (isElementInViewport(document.querySelector('.product__info-select-size-trigger'))) {
          entry.target.closest('.product-wrapper').querySelector('.sticky-atc').classList.remove('active');
        } else {
          entry.target.closest('.product-wrapper').querySelector('.sticky-atc').classList.add('active');
        }
      } else {
        entry.target.closest('.product-wrapper').querySelector('.sticky-atc').classList.remove('active');
      }
    });
  },
  {
    threshold: .025
  }
);    

if(document.querySelector('.sticky-atc')){
    atcObserver.observe(document.querySelector('.product__info-select-size-trigger'));
    const selector = document.querySelector('#main-carousel')

    if (window.innerWidth > 768 && selector) {
      setTimeout(() => {
        atcObserver2.observe(selector);  
      }, 50);
    }

    document.querySelector('.sticky-atc').addEventListener('click', () => {
      document.querySelector('.product__info-select-size-trigger').click()
    })  
}  

// Change description to sentence case
document.addEventListener('DOMContentLoaded', function () {
  function toSentenceCase(str) {
    return str
      .toLowerCase()
      .replace(/(^\s*[^a-zA-Z]*|[.!?]\s*[^a-zA-Z]*)([a-zA-Z])/g, (m, prefix, letter) => prefix + letter.toUpperCase())
      .replace(/\bma1\b/gi, "MA1")
      .replace(/\bmx1\b/gi, "MX1")
      .replace(/\bma\b/gi, "MA")
      .replace(/\bma-/gi, "MA-")
      .replace(/\bamiri\b/gi, "AMIRI")
      .replace(/\busa\b/gi, "USA");
  }

  function formatDescription() {
    if (document.getElementsByClassName('product__info-container').length < 1) return;

    document.querySelectorAll('.product__info-container .product__description').forEach(el => {
      if (el.classList.contains('case-updated')) return;
      el.querySelectorAll('p').forEach(p => {
        if (!p.classList.contains('case-updated') && p.innerText !== "") {
          p.innerText = toSentenceCase(p.innerText);
          p.classList.add('case-updated');
        }
      });
      el.classList.add('case-updated');
    });
  }

  const descriptionButton = document.querySelector('button[aria-controls="Description"]');
  if (descriptionButton) {
    descriptionButton.addEventListener('click', formatDescription);
  }
});
